import { ApiProperty } from "@nestjs/swagger";
export class PlantIdReq {
    @ApiProperty()
    plantId: number;
}